// extracted by mini-css-extract-plugin
module.exports = {"fontStyle":"BrandLibraryFontSelectControl_fontStyle__2Mw43"};